import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=02bedd32&scoped=true"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts"
import style0 from "./CustomerOrders.vue?vue&type=style&index=0&id=02bedd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bedd32",
  null
  
)

export default component.exports